import {arrowUpRightCircleSvg as Icon__small__arrowUpRightCircleSvg} from '../Icon__small/Icon__small--arrowUpRightCircle.js';

export var arrowUpRightCircle = {
  name: 'arrowUpRightCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowUpRightCircleSvg,
};
